(function (w, d, s, u) {
    if (w.oaiq) return;

    var q = function () {
      q.q.push(arguments);
    };
    
    q.q = [];
    w.oaiq = q;
    var js = d.createElement(s);
    js.async = true;
    js.src = u;
    var f = d.getElementsByTagName(s)[0];
    f.parentNode.insertBefore(js, f);
  })(window, document, "script", "https://bzrcdn.openai.com/sdk/oaiq.min.js");

  oaiq("init", {
    pixelId: "EteVfSn1hjtrTKuLS7qK3q",
});


(function () {
    var lastFired = 0;
    function trackLead() {
        var now = Date.now();
        if (now - lastFired < 2000) return;
        lastFired = now;
      
        oaiq(
            "measure",
            "lead_created",
            { type: "customer_action" }
        );

        console.log("[OAI Pixel] Init called");
      
    }

    window.addEventListener("message", function (event) {
      if (event.data && event.data.type === "hsFormCallback" &&
          event.data.eventName === "onFormSubmitted") {
        trackLead();
      }
    });
})();